import BaseService from './base.service';

export default class RecruitmentService extends BaseService {
    constructor(ctx) {
        super(ctx);
    }

    getNewsByCategory = query => {
        return this.get('/recruitment-news/news-by-category', query);
    };

    getNewsById = (news_id, query) => {
        return this.get(`/recruitment-news/${news_id}`, query);
    };
}
